import { useQuery } from "@tanstack/react-query"
import { MissionReviewStatusType } from "../models/MissionReview"
import { SensorList } from "../models/sensors/Sensor"
import { API, NexusSuccessResponse } from "./API"
import { QueryKeys } from "./QueryConfig"

export const useFindReviewStatus = (projectId?: string) => {
    return useQuery({
        queryKey: [QueryKeys.FIND_REVIEW_STATUS_BY_PROJECT, projectId],
        queryFn: async () => {
            if (!projectId) {
                throw new Error("Error in finding relevant mission information. No project selected.")
            }
            const result: NexusSuccessResponse<MissionReviewStatusType[]> = await API.get(
                `/missions/${projectId}/review_status`,
                "Couldn't fetch Review Status.",
            )

            return result.data
        },
    })
}

export const useFindMissionSensorList = (projectNumber: string) => {
    return useQuery({
        queryKey: [QueryKeys.FIND_SENSOR_LIST, projectNumber],
        queryFn: async () => {
            const result: NexusSuccessResponse<SensorList> = await API.get(
                `/sensors-by-project/${projectNumber}`,
                "Error retrieving sensor list.",
            )

            return result.data
        },
    })
}
